export type InfractionSeverity = 'MINOR' | 'MAJOR' | 'FATAL';

export interface StVOInfraction {
  id: string;
  code: string; // e.g. "§ 8 StVO", "§ 8 Abs. 1a StVO", "§ 206 StVO"
  title: string;
  description: string;
  severity: InfractionSeverity;
  pointsDeducted: number;
  timestamp: number; // in seconds from exam start
  position: { x: number; y: number; z: number };
}

export class InfractionLog {
  public infractions: StVOInfraction[] = [];
  public hasFatalInfraction: boolean = false;
  public totalScore: number = 100;

  public getInfractions(): StVOInfraction[] {
    return this.infractions;
  }

  public log(
    code: string,
    title: string,
    description: string,
    severity: InfractionSeverity,
    timestamp: number,
    position: { x: number; y: number; z: number }
  ): StVOInfraction {
    const points = severity === 'FATAL' ? 100 : severity === 'MAJOR' ? 20 : 5;
    if (severity === 'FATAL') {
      this.hasFatalInfraction = true;
    }

    this.totalScore = Math.max(0, this.totalScore - points);

    const infraction: StVOInfraction = {
      id: Math.random().toString(36).substring(2, 9),
      code,
      title,
      description,
      severity,
      pointsDeducted: points,
      timestamp,
      position,
    };

    this.infractions.push(infraction);
    return infraction;
  }

  public isPassed(): boolean {
    return !this.hasFatalInfraction && this.totalScore >= 75;
  }

  public reset() {
    this.infractions = [];
    this.hasFatalInfraction = false;
    this.totalScore = 100;
  }
}
